import React, { Component } from 'react';
import ChallengeService from '../../services/ChallengeService.js';
import { CLEAR_ACTIVITIES } from 'actions/types';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { translate } from 'react-i18next';

import Utils from '../../utils/Utils.js';
import Activities from './Activities.js';
import { addReport, toggleReaction } from 'actions/activities.js'
import { getActivities } from '../../reducers/activities';
import {fetchMyProfile} from 'actions/user.js';
import defaultChallengeImage from 'img/default-challenge-image.jpg';
import moment from 'moment';
import { DH_NOT_SUITABLE_GENERATOR } from 'constants';
import { isNull } from 'util';


class ActivitiesContainer extends Component {
    constructor(props) {
        super(props);
        this.busy = false; //use this in logic to avoid race conditions
        this.nextDate = null;
        this.state = {busy:false,showReportActivity:false,activity:null,challengeReportReason:null,showPopUpMenu:{}, id: 0}; //For rendering spinner - subject to setState() delay
        this.onScroll = this.onScroll.bind(this);
        this.setScrollContainer = this.setScrollContainer.bind(this);
        this.scrollContainer = null;
        this.onLikeActivity = this.onLikeActivity.bind(this);
        this.onShowReportActivity = this.onShowReportActivity.bind(this);
        this.onClickLink = this.onClickLink.bind(this);
        this.onAction = this.onAction.bind(this);
        this.onTogglePopUpMenu = this.onTogglePopUpMenu.bind(this);
        this.onShowPopUpMenu = this.onShowPopUpMenu.bind(this);
        this.getImage = this.getImage.bind(this);
    }

    componentWillMount() {
        this.nextPage();
        this.loadData();
    }

    componentWillUnmount() {
        this.props.dispatch({type:CLEAR_ACTIVITIES});
    }

    loadData() {
        if(this.props.userProfile) {
            return;
        }
        this.props.dispatch(fetchMyProfile({categories:false, health:false, rank:false}))
                    .then(()=>{
                        this.nextPage();
                    });
    }

    onScroll(event) {
        this.loadPageIfEndVisible();
    }

    setScrollContainer(el) {
        this.scrollContainer = el;
    }

    onClickLink(index, e) {
        e.preventDefault();
        var href = e.currentTarget.getAttribute('href'); // not entirely sure if we need this stuff
        this.props.history.push(href); // not entirely sure if we need this stuff
        this.onShowPopUpMenu(index, false);
    }

    onAction(navigation) {
        if(navigation) {
            var route = navigation.route;
            if(route) {
                this.props.history.push(route);
            }
        }
    }

    getMargin = (Margins, content) =>{
        if(content.render != 2){
            var currentMargins = {
                top: Margins['default'],
                right: Margins['default'],
                bottom: Margins['default'],
                left: Margins['default'],
            };
        } else {
            var currentMargins = {
                top: Margins['default'],
                right: '0',
                bottom: Margins['default'],
                left: '0',
            };
        }

        var foundParams = false;

        if(Boolean(content.margin)){
                    if(content.margin.top){
                        currentMargins.top = Boolean(Margins[content.margin.top]) ? Margins[content.margin.top] : content.margin.top;
                        foundParams= true;
                    }
                    if(content.margin.right){
                        currentMargins.right = Boolean(Margins[content.margin.right]) ? Margins[content.margin.right] : content.margin.right;
                        foundParams= true;
                    }
                    if(content.margin.bottom){
                        currentMargins.bottom = Boolean(Margins[content.margin.bottom]) ? Margins[content.margin.bottom] : content.margin.bottom;
                        foundParams= true;
                    }
                    if(content.margin.left){
                        currentMargins.left = Boolean(Margins[content.margin.left]) ? Margins[content.margin.left] : content.margin.left;
                        foundParams= true;
                    }         
        }
        if(!foundParams && content.margin){
                currentMargins.top = Boolean(Margins[content.margin]) ? Margins[content.margin] : content.margin;
                currentMargins.right =  Boolean(Margins[content.margin]) ? Margins[content.margin] : content.margin;
                currentMargins.bottom =  Boolean(Margins[content.margin]) ? Margins[content.margin] : content.margin;
                currentMargins.left =  Boolean(Margins[content.margin]) ? Margins[content.margin] : content.margin;
        }
        
        return currentMargins.top + "px " + currentMargins.right + "px " + currentMargins.bottom + "px " + currentMargins.left + "px ";
    }
        

    onTogglePopUpMenu(index, e) {
        this.state.showPopUpMenu[index] = !this.state.showPopUpMenu[index];
        this.setState({showPopUpMenu:this.state.showPopUpMenu});
        //this.setState(s => ({showPopUpMenu:!s.showPopUpMenu}));
    }

    onShowPopUpMenu(index, en) {
        this.state.showPopUpMenu[index] = en;
        this.setState({showPopUpMenu:this.state.showPopUpMenu});
        //this.setState({showPopUpMenu:en});
    }

    loadPageIfEndVisible() {
        if(this.scrollContainer) {
            var scrollTop =    this.scrollContainer.scrollTop;
            var scrollHeight = this.scrollContainer.scrollHeight;
            var clientHeight = this.scrollContainer.clientHeight;
            var lastPageInView = (scrollTop >= scrollHeight - 1.5*clientHeight);
            if(lastPageInView && this.busy==false && this.props.end==false) {
                this.nextPage();
            }
        }
    }

    nextPage() {
        if(!this.props.userProfile || this.busy) {
            return;
        }
        var date = this.nextDate || '';
        var pageSizeLimit=10;
        this.busy = true;
        this.setState({busy:true});
		console.log('nextPage', this.props.userProfile);
        ChallengeService[this.props.feedMethod || 'getActivityFeed'](date, pageSizeLimit, this.props.userProfile).then((result)=>{
            console.log('nextPage result=', result); 
            if(result.feedActions.length) {
                this.nextDate = result.summary.nextDate;
                this.props.dispatch({type:'ADD_ACTIVITIES', 
                                     activities:result.feedActions, 
                                     challengeReaction:result.challengeReaction,
                                     challengeReportReason:result.challengeReportReason, 
                                     nextDate:result.summary.nextDate});
                Utils.delay(100).then(()=>{this.loadPageIfEndVisible()});
            } else {
                this.props.dispatch({type:'SET_ACTIVITIES_END'}); 
            }
        })
        .catch((error)=> {
            console.error('ERROR:');
            console.error(error);
        })
        .then(()=>{
            this.busy = false;
            this.setState({busy:false});
        });

    }

    getDataType = (data, content) =>{
        var currentContent = content;
        var dataType = data;
        if(currentContent.dataTypeName == 'icon'){
            dataType = (<icon className = {dataType} />);
        } else if(currentContent.dataTypeName == 'integer' || currentContent.dataTypeName == 'decimal'){
            if(currentContent.dataTypeName == 'decimal'){
                var numBeforeDecimal = dataType.toString().substring(0, dataType.toString().indexOf('.'));
                var numAfterDecimal = dataType.toString().substring(dataType.toString().indexOf('.'));
                dataType = numBeforeDecimal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                dataType = dataType + numAfterDecimal;
            } else {
                dataType = dataType.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            switch(currentContent.subTypeName){
                case 'percent':
                    dataType = Boolean(currentContent.dataTypeName == 'integer') ? Math.round(dataType) + '%' : Math.round(dataType*100) + '%';
                    break;
                case 'minutes':
                    dataType = dataType + " min. ";
                    break;
                case 'calories':
                    dataType = dataType + ' cals. ';
                    break;   
            }
        } else if(currentContent.dataTypeName == 'date_time'){
            dataType = moment(currentContent.data).format('lll');
            switch(currentContent.subTypeName){
                case 'date':
                    dataType = moment(currentContent.data).format('LL');
                    break;
                case 'time':
                    dataType = moment(currentContent.data).format('LT');
                    break;
                case 'birth_date':
                    dataType = moment(currentContent.data).format('LL');
                    break;
                case 'relative_date_time':
                    var dt1 = new Date();
                    var dt2 = new Date(currentContent.data);
                    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
                    diff /= (60 * 60);
                    var result = Math.abs(Math.round(diff));
                    if(result < 24){
                        dataType = moment(currentContent.data).startOf('minute').fromNow();

                    }else{ 
                        dataType = moment(currentContent.data).format('lll');
                    }
                    break;         
            }
        } else if(currentContent.dataTypeName == 'currency'){
            dataType = null;
        } else if(currentContent.dataTypeName == 'photo' && !currentContent.render){
            dataType = <img src={'../../' + currentContent.data} />
        }

    return dataType;
}
    getData = (data, args, content, Palette, Margins, Sizes, Alignments) =>{
        var dataArray = (data != null ? String(data).match(/((\{.+?\})|([^\}\{]+))/g) : '');
        var argsMap = new Map();
        if(Boolean(args)){
            for(var i = 0; i < args.length; i++){
                argsMap.set('{' + args[i].arg + '}', args[i]);
            }
          }
        var concatenatedValues = [];
        var i = 0;
        var dataType;
        while(i < dataArray.length){
            if(argsMap.has(dataArray[i])){
                var argsData = argsMap.get(dataArray[i]);
                dataType = this.getDataType(argsData.data, argsMap.get(dataArray[i]));
                concatenatedValues.push(<span onClick={()=>this.onAction(argsData.navigation)} key={this.state.id++} style={{...(Utils.deref(argsData, 'navigation') ? {cursor: 'pointer'} : {}), 
                                        color: Palette[argsData.color],  
                                        fontSize: Boolean(Sizes[argsData.size]) ? Sizes[argsData.size] : argsData.size + 'px', 
                                        textAlign: Alignments[argsData.align], 
                                        margin: Margins[argsData.margin],
                                        fontWeight: Boolean(argsData.bold) ? 'bold' : '',
                                        fontStyle: Boolean(argsData.italics) ? 'italic' : '',
                                        textDecoration: Boolean(argsData.underline) ? 'underline' : ''}}>{dataType}</span>)
            } else {
                dataType = this.getDataType(dataArray[i], content);
                if(dataArray[i].includes('\n')){
                    concatenatedValues.push(<br key={this.state.id++} />);
                } else {
                    concatenatedValues.push(<span onClick={()=>this.onAction(content.navigation)} key={this.state.id++} style={{...(Utils.deref(content, 'navigation') ? {cursor: 'pointer'} : {})}}>{dataType}</span>);
                }
            }
            i++;
        }
        if(concatenatedValues.length == 0){
            return null;
        }else{ 
            return concatenatedValues;
        }
    }


   



    getImage(content) {
        return Utils.deref(content, 'asset.sourceUrl', ''); 
    }

    hasAvatar(activity) {
        return (activity.header) && 
               (activity.header.avatar!=null) && 
               ((activity.header.avatar.url||'').length>0);
    }
    async onLikeActivity(activity){
        this.props.toggleReaction(activity.id)
        let result = {};
        if (activity.feedActionReaction){
            result = await ChallengeService.removeActivityReaction(activity.id,1)
        }else{
            result = await ChallengeService.addActivityReaction(activity.id,1)
        }
    }
    onShowReportActivity(activity,challengeReportReason,flag){
        this.setState({showReportActivity:flag,activity:activity,challengeReportReason:challengeReportReason})
        this.onShowPopUpMenu(activity.id, false);
    }
   
    render() {
        return (
            <Activities {... this.state}
                        pageTitle={this.props.pageTitle}
                        activities={this.props.activities}
                        onScroll={this.onScroll}
                        hasAvatar={this.hasAvatar}
                        getImage={this.getImage}
                        setScrollContainer={this.setScrollContainer}
                        showReportActivity={this.state.showReportActivity}
                        challengeReportReason = {this.props.challengeReportReason}
                        activity = {this.state.activity}
                        onShowReportActivity={this.onShowReportActivity}
                        onLikeActivity={this.onLikeActivity}
                        busy={this.state.busy}
                        showPopUpMenu={this.state.showPopUpMenu}
                        onTogglePopUpMenu={this.onTogglePopUpMenu}
                        onShowPopUpMenu={this.onShowPopUpMenu}
                        onClickLink={this.onClickLink}
                        getData = {this.getData}
                        getMargin = {this.getMargin}
                        onAction={this.onAction} />
        );
    }
    
}


function mapStateToProps(state, ownProps) {
    return {
			userProfile: state.user.userProfile,
            activities : getActivities(state.activities),
            end:state.activities.end,
            nextDate : state.activities.nextDate,
            challengeReportReason : state.activities.challengeReportReason,
            challengeReaction : state.activities.challengeReaction
        };
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleReaction: (id) => dispatch(toggleReaction(id)),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(translate('newsfeed')(ActivitiesContainer)));



// WEBPACK FOOTER //
// ./src/modules/newsfeed/ActivitiesContainer.js